import './App.css';
import Navigator from "./app/navigation/router";
import {NotificationContainer} from 'react-notifications';

function App() {
    return <>
    
    <Navigator /><NotificationContainer/>
    
    </>;
}

export default App;
